<template>
    <v-card flat elevation="0" class="bible-form" max-height="700px" :loading="loading">
        <v-card-title>
            <span class="header2">{{ this.dataGathering.title }}</span>
        </v-card-title>
        <v-card-subtitle>
            <span class="header3">Paso {{ step }}</span>
        </v-card-subtitle>
        <v-divider v-if="showDivider"></v-divider>
        <v-card-text ref="dialogContent">
            <v-container>
                <v-stepper v-model="step">
                    <v-stepper-items>
                        <template v-for="(data, key1) in stepIndex">
                            <v-stepper-content :step="key1+1" :key="key1+1">
                                <v-row>
                                    <template v-for="(field, key2) in fields">
                                        <v-col :key="key2" v-if="field.step_index === data" cols="6" class="dialog-items">
                                            <span class="label">
                                                {{ field.title }}
                                            </span>
                                            <v-menu ref="menu" v-model="menu" offset-y min-width="auto"
                                                    :close-on-content-click="false"
                                                    :return-value="newDataRecord[field.id]"
                                                    transition="scale-transition" v-if="field.type==='date'">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="modelFormattedDate.replace(/-/g,'/')"
                                                                  class="input-text input-text--text-field body-text"
                                                                  readonly dense outlined required hide-details="auto"
                                                                  v-bind="attrs" v-on="on"/>
                                                </template>
                                                <v-date-picker v-model="modelFormattedDate"
                                                               color="hsla(201, 100%, 41%, 1)" show-adjacent-months
                                                               no-title :locale="$t('app.language').toString()"
                                                               @input="updateDate">
                                                    <v-spacer></v-spacer>
                                                    <v-btn text color="primary" @click="setDate">
                                                        OK
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                            <v-text-field v-model="newDataRecord[field.id]"
                                                          v-if="field.type==='string' && field.id !== 'academic_announcement'"
                                                          :type="getFieldType(field.id)"
                                                          class="input-text input-text--text-field body-text" dense
                                                          outlined required hide-details="auto"
                                                          @keydown="restrictInput($event, field.id)"
                                                          :min="field.id === 'take_times' ? 1 : null"
                                                          :rules="getFieldRules(field.id)"/>
                                            <v-select v-model="newDataRecord['academic_announcement']"
                                                      class='input-text input-text--select body-text'
                                                      hide-details dense required
                                                      placeholder="Seleccione..."
                                                      v-if="field.id === 'academic_announcement'"
                                                      :items="announcementsList" outlined/>
                                            <div style="padding-left: 8px;">
                                                <v-switch v-model="newDataRecord[field.id]"
                                                          v-if="field.type==='switch'" style="margin-top: 0 !important;"
                                                          class="input-text input-text--text-field body-text" dense required
                                                          inset hide-details="auto"/>
                                            </div>
                                        </v-col>
                                    </template>
                                </v-row>
                            </v-stepper-content>
                        </template>
                    </v-stepper-items>
                </v-stepper>
            </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions style="justify-content: space-between; padding-right: 34px; padding-left: 34px; flex-direction: row-reverse">
            <div>
                <v-btn class="v-btn--secondary" @click="cancel" style="margin-right: 8px">
                    {{ $tc('data_gatherings.cancel') }}
                </v-btn>
                <v-btn v-if="step === stepIndex.length" class="v-btn--primary" @click="save" :disabled="loading">
                    {{ $tc('data_gatherings.save') }}
                </v-btn>
                <v-btn v-if="step < stepIndex.length" class="v-btn--primary" @click="step++">
                    Siguiente
                </v-btn>
            </div>
            <v-btn v-if="step > 1" class="v-btn--secondary" @click="step--" style="margin-left: 0px !important;">
                Volver
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import {DataRecordsStore} from "@/Store/DataGatherings/DataRecordsStore";
import {mapState, mapWritableState, mapActions} from "pinia";
import ToastMixin from "@/Shared/toastMixin";
import {isNaN} from "lodash";

export default {
    mixins: [ToastMixin],
    data() {
        return {
            step: 1,
            showDivider: false,
            menu: false,
            modelFormattedDate: '',
            newDataRecord: {},
            rules: {
                moreThanZero: value => value > 0 || this.$t('bibles.validations.greater_than'),
                gradeRules: (value) => {
                    const regex = /^(\d+(\.\d+)?|\d+(\,\d+)?|R)$/;
                    return regex.test(value) || this.$t('bibles.validations.grades_validation')
                }
            },
            approved: true,
            announcementsList: ['Semestre 1','Semestre 2','Extraordinaria'],
            loading: false,
        }
    },
    created() {
        const dataRecordsKeys = this.columns.filter(value => value.step_index !== 0);
        dataRecordsKeys.map((record) => {
            record.cast_as === 'boolean' ? this.newDataRecord = {
                ...this.newDataRecord,
                [record.id]: false
            } : this.newDataRecord = {...this.newDataRecord, [record.id]: ''}
        });
    },
    mounted() {
        const dialogContent = this.$refs.dialogContent;
        dialogContent.addEventListener("scroll", this.handleScroll);
    },

    beforeDestroy() {
        const dialogContent = this.$refs.dialogContent;
        dialogContent.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        getFieldRules(field) {
            const rules = [];

            if (field === 'take_times') {
                rules.push(this.rules.moreThanZero);
            }

            if (field === 'grade') {
                rules.push(this.rules.gradeRules)
            }

            return rules;
        },
        getFieldType(field) {
            if (field === 'take_times' || field.value === 'credits') {
                return 'number';
            }
            return 'text';
        },
        handleScroll() {
            const dialogContent = this.$refs.dialogContent;
            if (dialogContent) {
                this.showDivider = dialogContent.scrollTop > 1;
            }
        },

        formatDate(date) {
            if (!date) {
                return '';
            }

            const parsedDate = new Date(date);

            if (isNaN(parsedDate.getTime())) {
                return '';
            }

            const year = parsedDate.getUTCFullYear();
            const month = String(parsedDate.getUTCMonth() + 1).padStart(2, '0');
            const day = String(parsedDate.getUTCDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        },

        setDate() {
            this.modelFormattedDate = this.formatDate(this.newDataRecord.birth_date);
            this.menu = false;
        },

        updateDate(date) {
            this.newDataRecord.birth_date = this.formatDate(date);
        },

        restrictInput(event, fieldValue) {

            if (fieldValue === 'grade') {
                const key = event.key;

                const regex = /^[\d\.R,]$/;

                const currentValue = this.newDataRecord.grade + key;

                if (this.containsValidCharacter(currentValue)) {
                    event.preventDefault();
                    return;
                }

                if (!regex.test(key) && key !== "Backspace") {
                    event.preventDefault();
                }

            }
        },

        containsValidCharacter(value) {
            const containsNumber = /\d/.test(value);
            const containsR = /R/.test(value);
            return containsNumber && containsR;
        },

        //Checks grade
        checkGrade(grade, type) {
            if (this.newDataRecord['grade'] !== 'R') {
                if (this.newDataRecord['approved'] || (this.newDataRecord['approved'] === 1)) {
                    if ((grade < 5 && type.includes('GRADE')) || (grade < 7 && type.includes('MASTER'))) {
                        this.approved = false;
                        this.showGradeNotification();
                        return;
                    }
                    this.approved = true;
                    return;
                }

                if (this.newDataRecord['suspended'] || (this.newDataRecord['suspended'] === 1)) {
                    if ((grade >= 5 && type.includes('GRADE')) || (grade >= 7 && type.includes('MASTER'))) {
                        this.approved = true;
                        this.showGradeNotification();
                        return;
                    }
                    this.approved = false;
                    return;
                }
            }
            this.showGradeNotification()
        },

        showGradeNotification() {
            this.toast().warning(this.$t('data_records.check_grade'));
        },

        savingProcess() {
            this.loading = true;

            this.store(this.newDataRecord)
                .catch()
                .then(() => {
                    this.$emit('cancel')
                })
                .finally(() => this.loading = false);
        },

        cancel() {
            this.$emit('cancel')
        },
        save() {
            if (!window.location.pathname.includes('bibles')) {
                this.savingProcess();
                return;
            }

            if (this.newDataRecord['take_times'] > 0) {
                this.checkGrade(this.newDataRecord['grade'], this.dataGathering.type.abbr);
                if (!this.approved && this.newDataRecord['suspended']) {
                    this.savingProcess();
                    return;
                }

                if (this.approved && !isNaN(this.newDataRecord['grade']) && this.newDataRecord['approved']) {
                    this.savingProcess();
                    return;
                }

                if (this.newDataRecord['grade'] === 'R' && this.newDataRecord['recognized']) {
                    this.savingProcess();
                    return;
                }

                if ((this.newDataRecord['not_presented'])) {
                    this.savingProcess();
                    return;
                }
            }
        },

        ...mapActions(DataRecordsStore, ['store']),
    },
    computed: {
        stepIndex() {
            const isSurveyPath = window.location.pathname.includes('surveys');
            if (isSurveyPath) {
                let indexes = [...new Set(this.columns.map((data) =>{
                    data.id === 'program' ? data.step_index = 1 : data.step_index;
                    return data.step_index
                }))].filter(element => element !== 0);

                return indexes;
            }
            let indexes = [...new Set(this.columns.map(data => data.step_index))].filter(element => element !== 0);

            return indexes;
        },

        fields() {
            return this.columns;
        },
        ...mapWritableState(DataRecordsStore, ['dataGathering']),
        ...mapState(DataRecordsStore, [
            'columns', 'showSteps'
        ]),
    },
    watch: {
        'newDataRecord.birth_date'(newVal) {
            this.modelFormattedDate = this.formatDate(newVal);
        },

        'newDataRecord.approved'(newVal) {
            if (newVal) {
                this.newDataRecord.recognized = false;
                this.newDataRecord.suspended = false;
                this.newDataRecord.not_presented = false;
                this.checkGrade(this.newDataRecord.grade, this.dataGathering.type.abbr);
            } else {
                this.approved = true;
            }
        },

        'newDataRecord.recognized'(newVal) {
            if (newVal) {
                this.newDataRecord.approved = false;
                this.newDataRecord.suspended = false;
                this.newDataRecord.not_presented = false;
                this.newDataRecord.enrollment_SIUU = false
                this.newDataRecord.grade === '' || this.newDataRecord.grade === null
                    ? this.newDataRecord.grade = 'R' : this.newDataRecord.grade;
                this.approved = false;
                this.showGradeNotification();
            }
        },

        'newDataRecord.suspended'(newVal) {
            if (newVal) {
                this.newDataRecord.approved = false;
                this.newDataRecord.recognized = false;
                this.newDataRecord.not_presented = false;
                this.checkGrade(this.newDataRecord.grade, this.dataGathering.type.abbr);
            }
        },

        'newDataRecord.not_presented'(newVal) {
            if (newVal) {
                this.newDataRecord.approved = false;
                this.newDataRecord.suspended = false;
                this.newDataRecord.recognized = false;
                this.approved = false;
                this.showGradeNotification();
            }
        },

        'newDataRecord.enrollment_SIUU'(newVal) {
            if (newVal) {
                this.newDataRecord.recognized = false;
            }
        },

        'newDataRecord.take_times'(newVal) {

            const takeTimes = parseInt(newVal);

            switch (takeTimes) {
                case 1:
                    this.newDataRecord.first_enrollment = true;
                    this.newDataRecord.second_enrollment = false;
                    this.newDataRecord.third_enrollment = false;
                    this.newDataRecord.fourth_enrollment = false;
                    break;
                case 2:
                    this.newDataRecord.first_enrollment = false;
                    this.newDataRecord.second_enrollment = true;
                    this.newDataRecord.third_enrollment = false;
                    this.newDataRecord.fourth_enrollment = false;
                    break;
                case 3:
                    this.newDataRecord.first_enrollment = false;
                    this.newDataRecord.second_enrollment = false;
                    this.newDataRecord.third_enrollment = true;
                    this.newDataRecord.fourth_enrollment = false;
                    break;
                case 4:
                default:
                    if (takeTimes >= 4) {
                        this.newDataRecord.first_enrollment = false;
                        this.newDataRecord.second_enrollment = false;
                        this.newDataRecord.third_enrollment = false;
                        this.newDataRecord.fourth_enrollment = true;
                    }
                    break;
            }
        },

        'newDataRecord.first_enrollment'(newVal) {
            if (newVal)
                this.newDataRecord.take_times = 1;
        },

        'newDataRecord.second_enrollment'(newVal) {
            if (newVal)
                this.newDataRecord.take_times = 2;
        },

        'newDataRecord.third_enrollment'(newVal) {
            if (newVal)
                this.newDataRecord.take_times = 3;
        },

        'newDataRecord.fourth_enrollment'(newVal) {
            if (newVal)
                this.newDataRecord.take_times = 4;
        }
    }
}
</script>

<style scoped lang="scss">

.dialog-items {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 8px !important;

    .v-input {
        align-items: flex-end !important;
    }
}

.bible-form-dialog .bible-form > .v-card__subtitle {
    padding: 21px 34px 0 !important;
}

::v-deep .v-date-picker-table {
    height: auto !important;
}

.v-stepper {
    box-shadow: none !important;
    background-color: inherit !important;
}

.v-stepper__items {
    background-color: inherit !important;
}

.v-stepper__content {
    padding: 0 !important;
}


</style>
